import React from 'react';
import Fab from '@mui/material/Fab';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { green } from '@mui/material/colors';

const fabGreenStyle = {
    color: 'common.white',
    bgcolor: green[500],
    '&:hover': {
        bgcolor: green[600],
    },
};

export default function FAB() {
    const [visible, setVisible] = React.useState(false);

    React.useEffect(() => {
        setVisible(true);
    }, []);

    return (
        <Fab
            sx={{
                position: 'fixed',
                bottom: 16,
                right: 16,
                width: 80,
                height: 80,
                ...fabGreenStyle,
                zIndex: 1000,
                opacity: visible ? 1 : 0,
                transform: visible ? 'scale(1)' : 'scale(0.8)',
                transition: 'opacity 0.4s ease-in, transform 0.4s ease-in',
            }}
            onClick={() => {
                window.open('https://api.whatsapp.com/send?phone=6287878000033&text=Hi Tennet, I Have Question', '_blank');
            }}
            aria-label="Whatsapp"
            color="primary"
        >
            <WhatsAppIcon sx={{ width: 48, height: 48 }} />
        </Fab>
    )
}